import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    postKeyWord: "",
    selectedTypeArr: [], // 招聘类型
    selectedAddrArr: [],
    selectedSalaryArr: [], // 薪酬类型
    selectedCompanyArr: [], // 所属公司
    ctrlUnderLevelListHide: true,
    ctrlHeaderHide: true,
    activeTopTab: 0,
    // serverUrl: 'http://10.133.5.70:8089/',
    // serverUrl: 'http://10.150.5.3:8089/', //廖应波
    // serverUrl: 'http://192.168.4.84:8484/', //测试
    // serverUrl: 'http://192.168.4.84:8095/', //测试1
    // serverUrl: "http://www.intretech.com/", //旧的正式
    serverUrl: 'https://uhrm.umsin.com:8089/', // 新版正式地址
    plat: !navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? "Web" : "Mobile",
    allPostData: [],
    showedPostLen: 0,
    currPagingNum: 0,
    showedPostData: [],
    showedPagingNum: 1, // 岗位分页页码
    showedPagingPost: [], // 岗位分页数据
    umsNumber: '',
    umsName: '',
    positionId: '',//用于详情页从不同页面跳转进去
    activeMobile: 1
  },
  mutations: {
    setActiveTopTab: (state, val) => {
      state.activeTopTab = val
    },
    setLevelHide: (state, val) => {
      state.ctrlUnderLevelListHide = val;
    },
    setShowedPost: (state, val) => {
      let num = 0;
      let arr = [];
      let aArr = [];
      let bArr = [];
      let hasType = state.selectedTypeArr.length !== 0;
      let hasSalary = state.selectedSalaryArr.length !== 0;
      // let hasAddr = state.selectedAddrArr.length !== 0;
      let hasComp = state.selectedCompanyArr.length !== 0;
      let postVal = val === undefined ? state.postKeyWord : val.trim();
      console.info(state.allPostData)
      if (hasSalary || hasComp || hasType || !!postVal) {
        for (let v of state.allPostData) {
          if ((hasSalary ? state.selectedSalaryArr.indexOf(v.jobCategory.toString()) !== -1 : true) && (hasComp ? state.selectedCompanyArr.indexOf(v.companyId) !== -1 : true) && (hasType ? state.selectedTypeArr.indexOf(v.workPlaceRegion) !== -1 : true) && (!!postVal ? v.positionName.indexOf(postVal) !== -1 : true)) {
            arr.push(v);
          }
        }
      } else {
        arr = [].concat(state.allPostData);
      }
      for (let i = 0; i < arr.length; i += 6) {
        bArr.push(++num);
        aArr.push(arr.slice(i, i + 6));
      }
      if (bArr.length > 4) {
        bArr = [1, 2, 3, '...', num];
      }
      state.postKeyWord = postVal;
      state.currPagingNum = 0;
      state.showedPostLen = arr.length;
      state.showedPostData = arr;
      state.showedPagingNum = aArr.length;
      state.showedPagingPost = aArr;
      console.log('数据：', state.selectedSalaryArr, '###', state.selectedCompanyArr, '###', state.selectedTypeArr, '###')
    },
  },
  getters: {
    // 可获取一些做过一定修饰的数据：
    serverUrl: state => {
      return state.serverUrl;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js